import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Spinner } from 'react-bootstrap'


export default function JapanContact() {

    const [loading, setLoading] = useState(true)

    useEffect(() => {
        setTimeout(() => setLoading(false), 300)
    }, [])

    return (
        <>
            {loading === false ? (
                <Container fluid>
                    <div className='greyHeader'>
                        <h1>Japan Contact information</h1>
                    </div>
                    <Container>
                        <Row className='paddingTop'>
                            <Col>
                                <h1>TDACS Sales and Support in Japan</h1>
                                <h2>For all inquiries regarding TDACS sales and support in Japan, please contact the MLS Corporation using the information below.</h2>
                                <br></br>
                                <p>MLS Corporation Marketing Dept.</p>
                                <p>2-4-12 Kounan, Minato-ku, Tokyo 108-0075, Japan</p>
                                <p>TEL : 03-6456-5005</p>
                                <p>FAX : 03-6744-2274</p>
                                <p>E-mail: MLS_Marketing_Dep@mls-corp.com</p>
                            </Col>
                            <Col>
                                <h1>TDACS の日本における販売とサポート</h1>
                                <h2>日本国内でのTDACS販売とサポートに関するすべてのお問い合わせは、下記の情報を使用して株式会社エム・エル・エスまでご連絡ください。</h2>
                                <br></br>
                                <p>株式会社エム・エル・エス　営業本部</p>
                                <p>東京都港区港南2-4-12</p>
                                <p>TEL : 03-6456-5005</p>
                                <p>FAX : 03-6744-2274</p>
                                <p>E-mail: MLS_Marketing_Dep@mls-corp.com</p>
                            </Col>
                        </Row>
                    </Container>
                </Container>
            ) : (
                <Spinner animation='border' role='status' className='spinner'>
                    <span className='invisible'>Loading...</span>
                </Spinner>
            )}
        </>
    )
}